import {createStore} from '@ngneat/elf';
import {selectManyByPredicate, withEntities} from "@ngneat/elf-entities";
import {Injectable} from "@angular/core";
import {
    erstatteAlleEntiteterMedForelder,
    forelderIdPredikat,
    hentFraLokallagerEllerNull,
    slettAlleEntiteterMedForeldre
} from "felles-ng2/tjenester/datalager/datatjeneste";
import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {Observable} from "rxjs";
import {MøtedeltakerId, MøtedeltakerModell, MøteId} from "felles-ng2/tjenester/ressurser/generertNg2HttpKlient";

const debug = initDebugger('MøtedeltakereDatatjeneste');

/** Datalager for {@link MøtedeltakerModell}. Bruker {@link MøteId} som forelder ( __forelderId = møteId ). */
@Injectable() //tilgjengeliggjøres via DatalagerModul
export class MøtedeltakereDatatjeneste {

    readonly møtedeltakerLager = createStore({name: 'møtedeltaker'}, withEntities<MøtedeltakerModell, 'id'>());

    /** Returnerer angitt møtedeltaker fra lokallager, eller null dersom ikke funnet */
    hentFraLokallager(id: MøtedeltakerId): MøtedeltakerModell | null {
        return hentFraLokallagerEllerNull(this.møtedeltakerLager, id);
    }

    /** Returnerer alle deltakere tilknyttet angitt møte fra lokallager */
    finnTilknyttetMøteFraLokallager(møteId: MøteId): Observable<MøtedeltakerModell[]> {
        return this.møtedeltakerLager.pipe(selectManyByPredicate(forelderIdPredikat(møteId)));
    }

    /** Erstatter alle deltakere for et møte i lokallageret */
    erstattDeltakereTilknyttetMøteILokallager(deltakere: MøtedeltakerModell[], møteId: MøteId): MøtedeltakerModell[] {
        debug('erstattDeltakereTilknyttetMøteILokallager', møteId, deltakere?.length);
        return erstatteAlleEntiteterMedForelder(this.møtedeltakerLager, deltakere ?? [], møteId);
    }

    /** Sletter alle deltakere tilknyttet angitte møter fra lokallageret */
    slettDeltakereTilknyttetMøterILokallager(møteIder: MøteId[]): void {
        debug('slettDeltakereTilknyttetMøterILokallager', møteIder);
        slettAlleEntiteterMedForeldre(this.møtedeltakerLager, møteIder);
    }
}
